// extracted by mini-css-extract-plugin
export default {"menuSidebar":"MenuSidebar_menuSidebar__DIGbd","menuList":"MenuSidebar_menuList__yI1M4","menuItem":"MenuSidebar_menuItem__SZDR3","active":"MenuSidebar_active__ju9aM"};